import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ACTIVATION_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/activation_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerActivationSubscription(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('subscription_id', args.data.subscription_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если активировали абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если активировали абонемент на странице с абонементами
            else {
                // Обновляем список с абонементами
                yield put(getSubscriptionsSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherActivationSubscription() {
    yield takeLatest(ACTIVATION_SUBSCRIPTION_SAGA, workerActivationSubscription);
}